'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildPlatformSpecificReports = undefined;

var _reselect = require('reselect');

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildPlatformSpecificReports = exports.buildPlatformSpecificReports = (0, _reselect.createSelector)(function (state) {
  return state.reportManagement.savedReports.data;
}, function (state) {
  return state.session.currentPlatformType;
}, function (reports, platform) {
  if ((0, _isEmpty2.default)(reports)) return [];
  var platformSpecificReport = reports.filter(function (report) {
    return (0, _get2.default)(JSON.parse(report.value), "query.platform_type", null) === platform || (0, _get2.default)(JSON.parse(report.value), "platform_type", null) === platform;
  } // add some code to accomodate for legacy reports
  );
  if ((0, _isEmpty2.default)(platformSpecificReport)) return [];
  return platformSpecificReport.sort(function (a, b) {
    return new Date(b.created_at) - new Date(a.created_at);
  });
});


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/anchorman/lib/store/reportManagement/selectors/index.js
// module id = 2748
// module chunks = 1